import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  did: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const didSlice = createSlice({
  name: "did",
  initialState: INITIAL_STATE,
  reducers: {
    fetchDidData: (state) => {
      state.did.isLoading = true;
    },
    fetchDidSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      did: {
        ...state.did,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    fetchDidFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      did: {
        ...state.did,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearDid: (state) => ({
      ...state,
      did: {
        ...state.did,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const { fetchDidData, fetchDidFailure, fetchDidSuccess, clearDid } =
  didSlice.actions;
export const DidReducer = didSlice.reducer;
